export default "__VITE_ASSET__jom1GnCu__"